/**
 * Boya Notra Neo — overview animations / swipers / packing tabs
 * Adapted for Shopify (GSAP ScrollTrigger + theme Swiper 11)
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function boot() {
    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;

    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }

    // type1 hero video → reveal text
    if ($('.notra-neo .type1').length) {
      function getVideoElement() {
        return window.innerWidth > 750
          ? document.querySelector('.notra-neo .type1 .pc')
          : document.querySelector('.notra-neo .type1 .tablet');
      }

      function handleVideoEnd() {
        $('.notra-neo .type1 .title').addClass('active');
        $('.notra-neo .type1 .summary').addClass('active');
        $('.notra-neo .type1 .banner-more').addClass('active');
      }

      $('.notra-neo .type1 .title').addClass('active');
      $('.notra-neo .type1 .summary').addClass('active');
      $('.notra-neo .type1 .banner-more').addClass('active');

      var video = getVideoElement();
      if (video) {
        video.addEventListener('play', handleVideoEnd);
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          video = getVideoElement();
          if (video) video.addEventListener('ended', handleVideoEnd);
        }, 100);
      });
    }

    // type4 scroll-triggered video
    if ($('.notra-neo .type4').length && window.innerWidth > 1024 && typeof gsap !== 'undefined') {
      var type4Video = document.querySelector('.type4 video');
      var textSection = document.querySelector('.type4 .text');
      if (type4Video && textSection) {
        textSection.style.opacity = '0';
        textSection.style.transition = 'opacity 1s ease';
        var hasPlayed = false;

        type4Video.addEventListener('ended', function () {
          if (!hasPlayed) {
            hasPlayed = true;
            textSection.style.opacity = '1';
          }
        });

        gsap.timeline({
          scrollTrigger: {
            trigger: '.type4',
            start: 'top center',
            end: 'bottom bottom',
            scrub: true,
            onEnter: function () {
              if (!hasPlayed) type4Video.play();
            },
            onEnterBack: function () {
              if (!hasPlayed) type4Video.play();
            }
          }
        });
      }
    }

    // type6 sticky expand
    // Target height must be full-bleed image height. Do NOT use .innerHeight() on
    // .fade-img img before load / under theme picture{height:100%} — that yields a tiny
    // number, so scrub animates 40vh → small (looks like shrinking instead of growing).
    if ($('.notra-neo .type6').length && typeof gsap !== 'undefined') {
      var $type6Img = $('.notra-neo .type6 .fade-img img');
      var type6ImgEl = $type6Img.get(0);

      function type6TargetHeight() {
        if (type6ImgEl && type6ImgEl.naturalWidth > 0) {
          return Math.round(
            (type6ImgEl.naturalHeight / type6ImgEl.naturalWidth) * window.innerWidth
          );
        }
        return window.innerHeight;
      }

      function initType6Expand() {
        var imgHeight = type6TargetHeight();
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.notra-neo .type6',
              start: 'top top',
              end: 'bottom bottom',
              scrub: true
            }
          })
          .to('.notra-neo .type6 .type-box .img', {
            height: imgHeight,
            maxHeight: '100%',
            maxWidth: '100%',
            width: '100%',
            borderRadius: '0',
            duration: 0.5
          });
      }

      if (type6ImgEl && !type6ImgEl.complete) {
        $type6Img.one('load', initType6Expand);
      } else {
        initType6Expand();
      }
    }

    // type10 items reveal
    if ($('.notra-neo .type10').length && $(window).width() > 750 && typeof gsap !== 'undefined') {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.notra-neo .type10',
            start: 'top top',
            end: 'bottom bottom',
            scrub: true
          }
        })
        // fromTo: don't rely on current inline styles as the end state
        .fromTo(
          '.notra-neo .type10 .bottom .item',
          { y: 100, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            stagger: 0.1,
            ease: 'none'
          }
        );
    }

    // type5 swiper + tab buttons
    if ($('.notra-neo .type5').length && typeof Swiper !== 'undefined') {
      var type5 = new Swiper('.type5 .swiper', {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        allowTouchMove: true,
        speed: 1200,
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
          prevEl: '.type5 .swiper-button-prev',
          nextEl: '.type5 .swiper-button-next'
        },
        on: {
          slideChangeTransitionStart: function () {
            $('.type5 .button .item').eq(this.activeIndex).trigger('click');
          }
        }
      });

      $('.type5 .button').each(function () {
        var buttonContainer = $(this);
        var item = buttonContainer.find('.item');
        var item_width = item.eq(0).innerWidth();
        var item_bg = buttonContainer.find('.item-bg');
        item_bg.css('width', item_width + 'px');

        item.on('click', function () {
          $(this).addClass('active').siblings().removeClass('active');
          item_width = $(this).innerWidth();
          var item_left = $(this).position().left;
          item_bg.css('width', item_width + 'px');
          item_bg.css('left', item_left + 'px');
          var index = $(this).index();
          type5.slideTo(index);
          if ($(window).innerWidth() <= 750) {
            $('.type5 .button').css('transform', 'translateX(' + (-item_left / item_width) * 135 + 'px)');
          }
        });
      });
    }

    // type7 swiper
    if ($('.notra-neo .type7').length && typeof Swiper !== 'undefined') {
      var type7 = new Swiper('.type7 .swiper', {
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        allowTouchMove: true,
        speed: 800,
        slidesPerView: 1.5,
        spaceBetween: 20,
        loop: false,
        navigation: {
          prevEl: '.type7 .swiper-button-prev',
          nextEl: '.type7 .swiper-button-next'
        },
        breakpoints: {
          750: {
            slidesPerView: 1.4,
            spaceBetween: 48
          },
          1024: {
            slidesPerView: 2.36,
            spaceBetween: 48
          }
        }
      });

      if (type7.autoplay) type7.autoplay.stop();

      if (typeof gsap !== 'undefined') {
        gsap.timeline({
          scrollTrigger: {
            trigger: '.type7',
            start: 'top center',
            end: 'bottom bottom',
            scrub: true,
            onEnter: function () {
              if (type7.autoplay) type7.autoplay.start();
            }
          }
        });
      }
    }

    // type9 feature switcher
    if ($('.notra-neo .type9').length) {
      $('.notra-neo .type9 .right .item').on('click', function () {
        var index = $(this).index();
        $(this).addClass('active').siblings().removeClass('active');
        $('.notra-neo .type9 .bg').eq(index).addClass('active').siblings().removeClass('active');
        $('.notra-neo .type9 .items .item').eq(index).addClass('active').siblings().removeClass('active');
        $('.notra-neo .type9 .left .item').eq(index).addClass('active').siblings().removeClass('active');
      });
    }

    // Packing list tabs
    $('.accessories').each(function () {
      var container = $(this);
      var productTypeItems = container.find('.product-type-menu .item');
      var tabsMidItems = container.find('.tabs-mid .m-item');
      var tabsChangeItems = container.find('.tabs-change > .item');

      productTypeItems.on('click', function () {
        var index = $(this).index();
        productTypeItems.removeClass('active');
        $(this).addClass('active');
        tabsMidItems.removeClass('active').eq(index).addClass('active');
        tabsChangeItems.removeClass('active').eq(index).addClass('active');
      });

      tabsMidItems.each(function (itemIndex) {
        var mItem = $(this);
        mItem.find('.item').on('click', function () {
          var childIndex = $(this).index();
          $('.overview .accessories .left .img').eq(childIndex).addClass('active').siblings().removeClass('active');
          mItem.find('.item').removeClass('active');
          $(this).addClass('active');
          var activeContentItem = tabsChangeItems.eq(itemIndex);
          activeContentItem.find('.i-box').removeClass('active').eq(childIndex).addClass('active');
        });
      });
    });
  }

  ready(boot);
  document.addEventListener('shopify:section:load', boot);
})();
